import React from 'react';
import Router from './components/router';



function App() {
  return (
    <>
      <Router />
    </>
  );
}

export default App;
